import _Typography from "@mui/material/Typography";
import _Box from "@mui/material/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import findIllus from '../assets/images/find-illus.svg';
function CreateCommunityCard({
  createCommunityCardActions
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#F3F6FF",
    borderRadius: 4,
    display: "flex",
    gap: 3,
    padding: 3,
    width: "100%"
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    height: 60
  }, /*#__PURE__*/React.createElement("img", {
    height: "100%",
    src: findIllus
  })), /*#__PURE__*/React.createElement(_Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Typography, null, t('commons.communities.search.create_community'))), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0
  }, createCommunityCardActions));
}
export default CreateCommunityCard;